export const fromSignupParam = "from_signup";
